module.exports = __webpack_public_path__ + "static/media/DPT.84de2710.png";